import React, { createContext, ReactNode, useContext } from 'react';
import NotFind from '../components/customLayout/notfind';
import Gender from '../components/customLayout/gender';
import Dialog from '../components/customLayout/dialog';

interface GlobalComponentsContextType {
  NotFind: typeof NotFind;
  Gender: typeof Gender;
  Dialog: typeof Dialog;
}

const GlobalComponentsContext = createContext<GlobalComponentsContextType | undefined>(undefined);

interface GlobalComponentsProviderProps {
  children: ReactNode;
}

export const GlobalComponentsProvider: React.FC<GlobalComponentsProviderProps> = ({ children }) => {
  const components = {
    NotFind,
    Gender,
    Dialog,
  };

  return (
    <GlobalComponentsContext.Provider value={components}>
      {children}
    </GlobalComponentsContext.Provider>
  );
};

export const useGlobalComponents = () => {
  const context = useContext(GlobalComponentsContext);
  if (context === undefined) {
    throw new Error('useGlobalComponents must be used within a GlobalComponentsProvider');
  }
  return context;
};
